@if (viewModel.isCommodityGroup) {
  <div class="commodity-group" [class.has-inconsistency]="viewModel.isOutOfSync">
    <div class="name">
      @if (viewModel.isOutOfSync) {
        <div class="inconsistency-error">
          <span class="error-icon">!</span>
          <span class="error-label">Inconsistency Error</span>
        </div>
      }

      <div class="commodity-code-row" [class.has-inconsistency]="viewModel.isOutOfSync">
        <span>{{ viewModel.commodityGroupName }}</span>

        @if (viewModel.isOutOfSync) {
          <button class="resolve-button" (click)="resolveInconsistency()">Resolve</button>
        }
      </div>
    </div>

    @if (viewModel.itemGroups[0]?.items?.[0]?.isSellableQuantityEnabled) {
      <div>{{ viewModel.totalSoldQuantity || 0 }} / {{ viewModel.totalSellableQuantity }}</div>
    }

    <div class="empty-column small">filler</div>

    <div class="small">
      @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin", "Division"])) {
        <span class="fake-link" (click)="editExternalItemNumberGroup()"> Edit Item </span>
      }
    </div>
  </div>
}
@for (group of viewModel.itemGroups; track group) {
  <div>
    @if (group.isExternalItemNumberGroup) {
      <div class="external-item row">
        @if (!isCommodityGroup) {
          <div class="flex-row external-item-number">
            @if (group.isOutOfSync) {
              <div class="error">
                <mat-icon color="warn">error</mat-icon>
                <span>Inconsistency Error</span>
              </div>
            }

            <div class="commodity-code-row" [class.has-inconsistency]="group.isOutOfSync">
              <span>Commodity Code {{ group.itemNumber }}</span>

              @if (group.isOutOfSync) {
                <button class="resolve-button" (click)="resolveInconsistency()">Resolve</button>
              }
            </div>
          </div>
        }
        @if (isCommodityGroup) {
          <div class="flex-row external-item-number">
            @if (group.isOutOfSync) {
              <div class="error">
                <mat-icon color="warn">error</mat-icon>
                <span>Inconsistency Error</span>
              </div>
            }
            <div class="commodity-code-row" [class.has-inconsistency]="group.isOutOfSync">
              <span>Commodity Code {{ group.itemNumber }} ({{ group.items[0].commodityGroupUnitQuantity }}x)</span>
              @if (group.isOutOfSync) {
                <button class="resolve-button" (click)="resolveInconsistency()">Resolve</button>
              }
            </div>
          </div>
        }
        <div class="flex-row medium">
          @if (group.items[0]?.isSellableQuantityEnabled) {
            <div>{{ group.totalSoldQuantity || 0 }} / {{ group.totalSellableQuantity | number: "1.0-2" }}</div>
          }
          @if (group.availabilityError) {
            <div class="error">
              <span>Inventory Error</span>
              <button class="action-button" (click)="externalItemNumberStockRefresh()">Turn off item(s)</button>
            </div>
          }
        </div>
        <div class="flex-row small">
          @if (!group.inventorySoldOut) {
            <label class="availability-switch">
              <mat-slide-toggle
                [ngModel]="group.isAvailable"
                (change)="externalItemNumberAvailability(group)"
                [disabled]="group.inventorySoldOut || group.availabilityError"></mat-slide-toggle>
            </label>
          }
          @if (group.inventorySoldOut) {
            <div class="tool-tip">
              <span class="tool-tip-text">Sold Out</span>
            </div>
          }
        </div>
        <div class="flex-row small">
          @if (
            authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin", "Division"])
            && !(group.isExternalItemNumberGroup && isCommodityGroup)
          ) {
            <span class="fake-link" (click)="editExternalItemNumberGroup()"> Edit Item </span>
          }
        </div>
      </div>
    }
    @for (currentItem of group.items; track currentItem) {
      <div class="row" [class.sub-item]="group.isExternalItemNumberGroup">
        @if (!group.isExternalItemNumberGroup && !isCommodityGroup) {
          <div class="flex-row cin small">
            {{ currentItem.externalItemNumber || currentItem.commerceItemNumber }}
          </div>
        }
        @if (!group.isExternalItemNumberGroup && isCommodityGroup) {
          <div class="flex-row cin small">
            {{ currentItem.externalItemNumber || currentItem.commerceItemNumber }} ({{
              currentItem.commodityGroupUnitQuantity
            }}x)
          </div>
        }
        @if (group.isExternalItemNumberGroup) {
          <div class="flex-row cin small"></div>
        }
        <div class="flex-row names large">
          @if (!currentItem.itemName) {
            <span>{{ currentItem.itemDescription }}</span>
          }
          @if (currentItem.itemName) {
            <span>{{ currentItem.itemName }}</span>
          }
        </div>
        <div class="flex-row names large">
          @if (currentItem.itemName) {
            <span>{{ currentItem.itemDescription }}</span>
          }
        </div>
        <div class="flex-row small">{{ currentItem.leadMinutes | leadMinutesFormat }}</div>
        <div class="flex-row small">{{ currentItem.prepMinutes | prepMinutesFormat }}</div>
        <div class="flex-row medium">
          <span>{{ getFormattedPickupDates(currentItem) }}</span>
        </div>
        <div class="flex-row medium">
          @if (displayHandoffTypes(currentItem)) {
            <div>
              @for (handoffType of getHandoffRestrictions(currentItem); track handoffType) {
                <div>
                  <span>Not available for {{ handoffType }}</span>
                </div>
              }
            </div>
          }
        </div>
        <div class="flex-row medium">
          @if (currentItem.isSellableQuantityEnabled) {
            <div>{{ currentItem.soldQuantity || 0 }} / {{ currentItem.sellableQuantity | number: "1.0-2" }}</div>
          }
          @if (group.availabilityError) {
            <div class="error">
              <span>Inventory Error</span>
              @if (authManager.isCurrentAccountAdminOrITRole()) {
                <button class="action-button" (click)="externalItemNumberStockRefresh()">Turn off item(s)</button>
              }
            </div>
          }
        </div>
        <div class="flex-row small">
          @if (group.isExternalItemNumberGroup === false && !group.inventorySoldOut) {
            <label class="availability-switch">
              <mat-slide-toggle
                [ngModel]="group.isAvailable"
                (click)="externalItemNumberAvailability(group)"
                [disabled]="group.inventorySoldOut || group.availabilityError"></mat-slide-toggle>
            </label>
          }
          @if (group.inventorySoldOut) {
            <div class="tool-tip">
              <span class="tool-tip-text">Sold Out</span>
            </div>
          }
        </div>
        <div class="flex-row small">
          @if (
            !group.isExternalItemNumberGroup
            && !viewModel.isCommodityGroup
            && authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin", "Division"])
          ) {
            <span class="fake-link" (click)="editExternalItemNumberGroup()"> Edit Item </span>
          }
        </div>
      </div>
    }
  </div>
}
